import request from '@/request'
export function getList(params) {
    return request({
        url: 'site/article/list',
        method: 'get',
        params: params
    })
}
export function getChildList(params) {
    return request({
        url: 'site/article/child/list',
        method: 'get',
        params: params
    })
}
export function details(params) {
    return request({
        url: `site/article/${params}`,
        method: 'get'
    })
}
export function menuList(params) {
    return request({
        url: `site/menu/tree`,
        method: 'get',
        params: params
    })
}
export function bannerList(params) {
    return request({
        url: `site/banner/list`,
        method: 'get',
        params: params
    })
}